// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"170":"c88c731f","193":"6fde8e7e","320":"e4b9f071","978":"906328c3"}[chunkId] + ".js";
};